import React from 'react';
import { LocalizableMessage } from 'components/LocalizableMessage/LocalizableMessage';
import { creditsLabels } from '../../filters/filters.messages';
import { CREDITS_FILTER_MAX_CREDITS } from '../../Search.constants';
import { getCreditsFilterDisplayValues, creditsRangeShape } from '../../filters/filters.helpers';

export const CreditsRangeLabel = ({ creditsRange }) => {
  const [numCreditsFrom, numCreditsTo] = getCreditsFilterDisplayValues(creditsRange);

  if (numCreditsFrom === numCreditsTo) {
    if (numCreditsTo === CREDITS_FILTER_MAX_CREDITS) {
      return (
        <LocalizableMessage
          message={creditsLabels.maxCredits}
          values={{
            numCredits: numCreditsTo,
          }}
        />
      );
    }

    return (
      <LocalizableMessage
        message={creditsLabels.singleAmount}
        values={{
          numCredits: numCreditsTo,
        }}
      />
    );
  }

  if (numCreditsTo === CREDITS_FILTER_MAX_CREDITS) {
    return (
      <LocalizableMessage
        message={creditsLabels.rangeWithMax}
        values={{
          low: numCreditsFrom,
          high: CREDITS_FILTER_MAX_CREDITS,
        }}
      />
    );
  }

  return (
    <LocalizableMessage
      message={creditsLabels.range}
      values={{
        low: numCreditsFrom,
        high: numCreditsTo,
      }}
    />
  );
};

CreditsRangeLabel.propTypes = {
  creditsRange: creditsRangeShape,
};
